import { Button, Tooltip } from "@mui/material";
import type { TooltipProps } from "@mui/material";

interface TSSecondaryButtonProps {
  text: string;
  onClick: any;
  styles?: any;
  tooltipProps?: {
    title: TooltipProps["title"];
    placement: TooltipProps["placement"];
  };
}

const TSSecondaryButton = ({ text, onClick, styles, tooltipProps }: TSSecondaryButtonProps) =>
  tooltipProps ? (
    <Tooltip {...tooltipProps}>
      <Button
        onClick={onClick}
        variant="outlined"
        sx={{
          textTransform: "none",
          borderRadius: "4px",
          border: "1.5px solid #239B8B",
          fontSize: "15px",
          fontWeight: 700,
          // whiteSpace: "nowrap",
          height: "100%",
          "&:hover": {
            border: "1.5px solid #239B8B",
          },
          ...styles,
        }}
      >
        {text}
      </Button>
    </Tooltip>
  ) : (
    <Button
      onClick={onClick}
      variant="outlined"
      sx={{
        textTransform: "none",
        borderRadius: "4px",
        border: "1.5px solid #239B8B",
        fontSize: "15px",
        fontWeight: 700,
        "&:hover": {
          border: "1.5px solid #239B8B",
        },
        ...styles,
      }}
    >
      {text}
    </Button>
  );

export default TSSecondaryButton;
